import { type Color } from '@mui/material'

export const red = {
  100: '#230C0D',
  200: '#23100C',
  300: '#671B0A',
  400: '#932209',
  500: '#C02907',
  600: '#ED3006',
  700: '#F15938',
  800: '#F4836A',
  900: '#F8AC9B',
} satisfies Partial<Color>
